import {
  IN_PERSON_SESSION_PRE_AUTH_MULTIPLIER,
  PRE_AUTH_DURATION_BUFFER,
} from './constants';

/**
 * Minutes of the stylist's rate held on Stripe when a scheduled session is booked.
 * In-person: 1.5× booked time (2hr → 3hr). Virtual: booked time + 30 min (60 → 90).
 * Keep in sync with the billing cap in backend/src/shared/helpers/payment.ts.
 */
export const getPreAuthDurationMinutes = (
  sessionDuration: number,
  isInPersonSession: boolean,
) =>
  isInPersonSession
    ? Math.round(sessionDuration * IN_PERSON_SESSION_PRE_AUTH_MULTIPLIER)
    : sessionDuration + PRE_AUTH_DURATION_BUFFER;

/**
 * Booking summary fine print explaining the Stripe hold placed at booking.
 * The multiple comes from the same hold duration BookingModal charges, so it
 * reads "1.5 times" for in-person and 60-min virtual, and "twice" for 30-min
 * virtual (30 → 60 min hold).
 */
export const getPreAuthNotice = (
  sessionDuration: number,
  isInPersonSession: boolean,
) => {
  const multiple =
    getPreAuthDurationMinutes(sessionDuration, isInPersonSession) /
    sessionDuration;
  const holdMultiple = multiple === 2 ? 'twice' : `${multiple} times`;

  return (
    'Your estimate reflects your stylist’s rate and booked time. ' +
    `A temporary hold of ${holdMultiple} this amount will appear on your card to cover additional time. ` +
    'After your session, we’ll charge the final total and release the remaining hold.'
  );
};
